import script from "./VoidModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VoidModal.vue?vue&type=script&setup=true&lang=js"

import "./VoidModal.vue?vue&type=style&index=0&id=75aeb741&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75aeb741"]])

export default __exports__